import { render, staticRenderFns } from "./CopyRight.vue?vue&type=template&id=11cf495c&scoped=true"
var script = {}
import style0 from "./CopyRight.vue?vue&type=style&index=0&id=11cf495c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11cf495c",
  null
  
)

export default component.exports